import { useContext } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { ModalTotalContext } from '../context/ModalContext'
import api from './API'

export const useUpdateExpenses = () => {
  const queryClient = useQueryClient()
  return useMutation((data) => api.updateExpenses(data), {
    onMutate: (data) => {
      queryClient.cancelQueries('profile')
      queryClient.setQueryData('profile', (old) => Object.assign(old, data))
    },

    onSuccess: () => {
      toast.success('Despesas atualizadas')
    },
    onError: (err, context) => {
      toast.error('Algo deu errado, estado revertido')
      queryClient.setQueryData(['profile'], context.previousTodos)
    },
    onSettled: () => {
      queryClient.refetchQueries('profile')
      queryClient.refetchQueries('madeProducts')
    },
  })
}

export const useAddPlataforms = () => {
  const queryClient = useQueryClient()
  return useMutation((data) => api.addPlataforms(data), {
    onError: (err, context) => {
      toast.error('Algo deu errado, estado revertido')
      queryClient.setQueryData(['plataforms'], context.previousTodos)
    },
    onSettled: () => {
      queryClient.refetchQueries('plataforms')
    },
    onSuccess: () => {
      toast.success('Despesas das plataformas atualizadas')
    },
  })
}

export const useAddMethodsSales = () => {
  const queryClient = useQueryClient()
  return useMutation((data) => api.addMethodsSales(data), {
    onError: (err, context) => {
      toast.error('Algo deu errado, estado revertido')
      queryClient.setQueryData(['methodsSales'], context.previousTodos)
    },
    onSettled: () => {
      queryClient.refetchQueries('methodsSales')
    },
    onSuccess: () => {},
  })
}

export const useAddNotesSales = () => {
  const queryClient = useQueryClient()
  return useMutation((data) => api.addNotesSales(data), {
    onError: (err, context) => {
      toast.error('Algo deu errado, estado revertido')
      queryClient.setQueryData(['notesSalesAll'], context.previousTodos)
      queryClient.setQueryData(['notesSales'], context.previousTodos)
    },
    onSettled: () => {
      queryClient.refetchQueries('notesSalesAll')
      queryClient.refetchQueries('notesSales')
    },
    onSuccess: () => {},
  })
}

export const useAddAppSales = () => {
  const queryClient = useQueryClient()
  return useMutation((data) => api.addAppSales(data), {
    onError: (err, context) => {
      toast.error('Algo deu errado, estado revertido')
      queryClient.setQueryData(['appSales'], context.previousTodos)
    },
    onSettled: () => {
      queryClient.refetchQueries('appSales')
    },
    onSuccess: () => {},
  })
}

export const useAddComponent = () => {
  const queryClient = useQueryClient()
  const { setOpenModal } = useContext(ModalTotalContext)

  return useMutation((data) => api.addProduct(data), {
    onMutate: (data) => {
      queryClient.cancelQueries('components')
      queryClient.setQueryData('components', (old) => [...old, data])
      toast.success('Componente criado com sucesso')
    },
    onSuccess: () => {
      setOpenModal(null)
    },
    onError: (err, context) => {
      toast.error('Algo deu errado, estado revertido')
      queryClient.setQueryData(['components'], context.previousTodos)
    },
    onSettled: () => {
      queryClient.refetchQueries('components')
    },
  })
}

export const useUpdateComponent = () => {
  const queryClient = useQueryClient()
  const { setOpenModal } = useContext(ModalTotalContext)

  return useMutation((data) => api.updateProduct(data), {
    onMutate: (data) => {
      queryClient.cancelQueries('components')
      queryClient.setQueryData('components', (old) =>
        old.map((item) =>
          item.id === data.id
            ? { ...item, ...data, valor_unit: data.valor / data.quantidade }
            : item
        )
      )

      toast.success('Componente atualizado com sucesso')
    },
    onSuccess: () => {
      setOpenModal(null)
    },
    onError: (err, context) => {
      toast.error('Algo deu errado, estado revertido')
      queryClient.setQueryData(['components'], context.previousTodos)
    },
  })
}

export const useDeleteComponent = () => {
  const { setOpenModal } = useContext(ModalTotalContext)
  const queryClient = useQueryClient()
  return useMutation((id) => api.deleteProduct(id), {
    onMutate: (id) => {
      queryClient.cancelQueries('components')
      const previousTodos = queryClient.getQueryData(['components'])
      queryClient.setQueryData('components', (old) =>
        old.filter((component) => component.id !== id)
      )
      setOpenModal(null)

      return { previousTodos }
    },

    onError: (err, context) => {
      toast.error('Algo deu errado, estado revertido')
      queryClient.setQueryData(['components'], context.previousTodos)
      setOpenModal(null)
    },
    onSuccess: () => {
      toast.success('Componente deletado com sucesso')
    },
    onSettled: () => {
      queryClient.refetchQueries('components')
    },
  })
}

export const useAddProduct = () => {
  const queryClient = useQueryClient()

  return useMutation((data) => api.addMadeProduct(data), {
    onMutate: () => {
      queryClient.cancelQueries('madeProducts')
    },
    onSuccess: () => {
      toast.success('Produto criado com sucesso')
    },
    onError: (err, context) => {
      toast.error('Algo deu errado, estado revertido')
      queryClient.setQueryData(['madeProducts'], context.previousTodos)
    },
    onSettled: () => {
      queryClient.refetchQueries('madeProducts')
    },
  })
}

export const useDeleteProduct = () => {
  const { setOpenModal } = useContext(ModalTotalContext)
  const queryClient = useQueryClient()
  return useMutation((id) => api.deleteMadeProduct(id), {
    onMutate: (id) => {
      queryClient.cancelQueries('madeProducts')
      const previousTodos = queryClient.getQueryData(['madeProducts'])
      queryClient.setQueryData('madeProducts', (old) =>
        old.filter((component) => component.id !== id)
      )
      setOpenModal(null)
      return { previousTodos }
    },

    onError: (context) => {
      toast.error('Algo deu errado, estado revertido')
      queryClient.setQueryData(['madeProducts'], context.previousTodos)
    },
    onSuccess: () => {
      toast.success('Produto deletado com sucesso')
    },
  })
}

export const useAddFixedExpenses = () => {
  const queryClient = useQueryClient()
  return useMutation((data) => api.addFixedExpense(data), {
    onError: () => {
      toast.error('Algo deu errado, estado revertido')
    },
    onSettled: () => {
      queryClient.refetchQueries('fixed')
    },
  })
}

export const useAddFixedExpensesSales = () => {
  const queryClient = useQueryClient()
  return useMutation((data) => api.addFixedExpenseSales(data), {
    onError: () => {
      toast.error('Algo deu errado, estado revertido')
    },
    onSettled: () => {
      queryClient.refetchQueries('fixedSales')
      queryClient.refetchQueries('profile')
    },
  })
}

export const useDeleteFixedExpenses = () => {
  const queryClient = useQueryClient()
  return useMutation((data) => api.deleteFixedExpenses(data), {
    onError: () => {
      toast.error('Algo deu errado, estado revertido')
    },
    onSettled: () => {
      queryClient.refetchQueries('fixed')
    },
  })
}

export const useDeleteMethodsSales = () => {
  const queryClient = useQueryClient()
  return useMutation((data) => api.deleteMethodsSales(data), {
    onError: () => {
      toast.error('Algo deu errado, estado revertido')
    },
    onSettled: () => {
      queryClient.refetchQueries('methodsSales')
    },
  })
}

export const useUpdateFixedExpenses = () => {
  const queryClient = useQueryClient()
  return useMutation((data) => api.updateFixedExpenses(data), {
    onError: () => {
      toast.error('Algo deu errado, estado revertido')
    },
    onSettled: () => {
      queryClient.refetchQueries('fixed')
    },
  })
}

export const useUpdateFixedExpensesSales = () => {
  const queryClient = useQueryClient()
  return useMutation((data) => api.updateFixedExpensesSales(data), {
    onError: () => {
      toast.error('Algo deu errado, estado revertido')
    },
    onSettled: () => {
      queryClient.refetchQueries('fixedSales')
      queryClient.refetchQueries('profile')
    },
  })
}
